import view from './paymentMethod.view.html';
import './paymentMethod.scss';
import paymentDataService from '../../../services/PaymentDataService';
import { BUILDER_PAYMENT_METHOD_SELECTED, BUILDER_PAYMENT_METHOD_ADDITIONAL_SELECTED, BUILDER_PAYMENT_METHOD_ADDITIONAL_ENABLED, } from '../../../events';
class PaymentMethodController {
    static $inject = ['$timeout', '$scope', '$translate', 'PaymentSegmentService'];
    constructor($timeout, $scope, $translate, PaymentSegmentService) {
        'ngInject';
        this.showMethod2 = false;
        this.showInfoMethod1 = true;
        this.showInfoMethod2 = true;
        this.paymentMethodOptions = [];
        this.keyTypeOptions = [];
        this.paymentData = {
            method1: {
                type: '',
                config: {
                    business: '',
                    keyType: '',
                    pixKey: '',
                    pixCode: '',
                    httpsLink: '',
                    boletoCode: '',
                },
            },
            method2: {
                type: '',
                config: {
                    business: '',
                    keyType: '',
                    pixKey: '',
                    pixCode: '',
                    httpsLink: '',
                    boletoCode: '',
                },
            },
        };
        //#endregion
        //#region Lifecycle Hooks
        this.$onInit = () => {
            if (this.state && this.PaymentSegmentService?.setState) {
                this.PaymentSegmentService.setState(this.state);
            }
            this.paymentMethodOptions = [
                {
                    label: this.$translate.instant('builder.payment.paymentMethod.pixcopycode'),
                    value: 'pixcopycode',
                },
                {
                    label: this.$translate.instant('builder.payment.paymentMethod.boleto'),
                    value: 'barcode',
                },
                {
                    label: this.$translate.instant('builder.payment.paymentMethod.paymentlink'),
                    value: 'paymentlink',
                },
            ];
            this.keyTypeOptions = [
                {
                    label: this.$translate.instant('builder.payment.paymentMethod.keyTypeCpf'),
                    value: 'cpf',
                },
                {
                    label: this.$translate.instant('builder.payment.paymentMethod.keyTypeCnpj'),
                    value: 'cnpj',
                },
                {
                    label: this.$translate.instant('builder.payment.paymentMethod.keyTypeEmail'),
                    value: 'email',
                },
                {
                    label: this.$translate.instant('builder.payment.paymentMethod.keyTypeTelefone'),
                    value: 'telefone',
                },
                {
                    label: this.$translate.instant('builder.payment.paymentMethod.keyTypeRandom'),
                    value: 'random',
                },
            ];
            this.$timeout(() => {
                this.loadSavedData();
                this.$scope.$applyAsync();
            }, 0);
        };
        this.onPaymentMethod1Change = (event) => {
            const newValue = event.detail.value;
            // Se a mesma opção já está selecionada no método 2, limpa ela
            if (newValue === this.paymentData.method2.type) {
                this.paymentData.method2.type = '';
                this.clearMethod2Config();
            }
            this.paymentData.method1.type = newValue;
            this.saveToJSON();
            this.trackChangePaymentMethod(newValue);
        };
        this.onPaymentMethod2Change = (event) => {
            const newValue = event.detail.value;
            // Se a mesma opção já está selecionada no método 1, limpa ela
            if (newValue === this.paymentData.method1.type) {
                this.paymentData.method1.type = '';
                this.clearMethod1Config();
            }
            this.paymentData.method2.type = newValue;
            this.saveToJSON();
            this.trackChangePaymentMethodAdditional(newValue);
        };
        this.onKeyType1Change = (event) => {
            this.paymentData.method1.config.keyType = event.detail.value;
            this.saveToJSON();
        };
        this.onKeyType2Change = (event) => {
            this.paymentData.method2.config.keyType = event.detail.value;
            this.saveToJSON();
        };
        this.onBusiness1Blur = (event) => {
            const value = event.detail?.value || event.target?.value || '';
            this.paymentData.method1.config.business = value;
            this.saveToJSON();
        };
        this.onBusiness2Blur = (event) => {
            const value = event.detail?.value || event.target?.value || '';
            this.paymentData.method2.config.business = value;
            this.saveToJSON();
        };
        this.onPixKey1Blur = (event) => {
            const value = event.detail?.value || event.target?.value || '';
            this.paymentData.method1.config.pixKey = value;
            this.saveToJSON();
        };
        this.onPixKey2Blur = (event) => {
            const value = event.detail?.value || event.target?.value || '';
            this.paymentData.method2.config.pixKey = value;
            this.saveToJSON();
        };
        this.onPixCode1Blur = (event) => {
            const value = event.detail?.value || event.target?.value || '';
            this.paymentData.method1.config.pixCode = value;
            this.saveToJSON();
        };
        this.onPixCode2Blur = (event) => {
            const value = event.detail?.value || event.target?.value || '';
            this.paymentData.method2.config.pixCode = value;
            this.saveToJSON();
        };
        this.onHttpsLink1Blur = (event) => {
            const value = event.detail?.value || event.target?.value || '';
            this.paymentData.method1.config.httpsLink = value;
            this.saveToJSON();
        };
        this.onHttpsLink2Blur = (event) => {
            const value = event.detail?.value || event.target?.value || '';
            this.paymentData.method2.config.httpsLink = value;
            this.saveToJSON();
        };
        this.onBoletoCode1Blur = (event) => {
            const value = event.detail?.value || event.target?.value || '';
            this.paymentData.method1.config.boletoCode = value;
            this.saveToJSON();
        };
        this.onBoletoCode2Blur = (event) => {
            const value = event.detail?.value || event.target?.value || '';
            this.paymentData.method2.config.boletoCode = value;
            this.saveToJSON();
        };
        this.getPaymentMethod1Icon = () => {
            switch (this.selectedPaymentMethod1) {
                case 'pixcopycode':
                    return 'pix';
                case 'boleto':
                    return 'barcode';
                case 'paymentlink':
                    return 'link';
                default:
                    return '';
            }
        };
        this.getPaymentMethod2Icon = () => {
            switch (this.selectedPaymentMethod2) {
                case 'pixcopycode':
                    return 'pix';
                case 'boleto':
                    return 'barcode';
                case 'paymentlink':
                    return 'link';
                default:
                    return '';
            }
        };
        this.loadSavedData = () => {
            if (!this.state)
                return;
            const savedData = paymentDataService.getPaymentMethodData(this.state);
            if (savedData) {
                if (savedData.method1) {
                    this.paymentData.method1 = {
                        ...this.paymentData.method1,
                        ...savedData.method1,
                    };
                }
                if (savedData.method2) {
                    this.paymentData.method2 = {
                        ...this.paymentData.method2,
                        ...savedData.method2,
                    };
                }
                if (savedData.showMethod2 !== undefined) {
                    this.showMethod2 = savedData.showMethod2;
                }
            }
        };
        this.toggleMethod2 = (event) => {
            const switchValue = event.detail.checked;
            if (this.showMethod2 === switchValue) {
                return;
            }
            this.showMethod2 = switchValue;
            this.saveToJSON();
            this.trackEnabledPaymentMethodAdditional(switchValue);
        };
        this.updateSetVariableAction = () => {
            if (!this.state)
                return;
            const paymentMethodData = {
                showMethod2: this.showMethod2,
                method1: this.paymentData.method1,
                method2: this.paymentData.method2,
            };
            paymentDataService.updatePaymentMethodData(this.state, paymentMethodData);
        };
        this.saveToJSON = () => {
            if (!this.state)
                return '';
            const paymentMethodData = {
                showMethod2: this.showMethod2,
                method1: this.paymentData.method1,
                method2: this.paymentData.method2,
            };
            this.updateSetVariableAction();
            if (this.onPaymentMethodChange) {
                this.onPaymentMethodChange({ paymentMethodData });
            }
            return JSON.stringify(paymentMethodData, null, 2);
        };
        this.getPaymentJSON = () => {
            return this.saveToJSON();
        };
        this.getFilteredMethod1Options = () => {
            if (!this.showMethod2) {
                return this.paymentMethodOptions;
            }
            return this.paymentMethodOptions.filter(option => option.value !== this.selectedPaymentMethod2);
        };
        this.getFilteredMethod2Options = () => {
            return this.paymentMethodOptions.filter(option => option.value !== this.selectedPaymentMethod1);
        };
        this.clearMethod1Config = () => {
            this.paymentData.method1.config = {
                business: '',
                keyType: '',
                pixKey: '',
                pixCode: '',
                httpsLink: '',
                boletoCode: '',
            };
        };
        this.clearMethod2Config = () => {
            this.paymentData.method2.config = {
                business: '',
                keyType: '',
                pixKey: '',
                pixCode: '',
                httpsLink: '',
                boletoCode: '',
            };
        };
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$translate = $translate;
        this.PaymentSegmentService = PaymentSegmentService;
    }
    //#endregion
    //#region Methods
    toggleInfoMethod1() {
        this.showInfoMethod1 = !this.showInfoMethod1;
    }
    toggleInfoMethod2() {
        this.showInfoMethod2 = !this.showInfoMethod2;
    }
    get selectedPaymentMethod1() {
        return this.paymentData.method1.type;
    }
    get selectedPaymentMethod2() {
        return this.paymentData.method2.type;
    }
    //#endregion
    //#region tracking
    trackChangePaymentMethod(methodType) {
        this.PaymentSegmentService.trackPaymentBlock(BUILDER_PAYMENT_METHOD_SELECTED, { methodType: methodType });
    }
    trackChangePaymentMethodAdditional(methodType) {
        this.PaymentSegmentService.trackPaymentBlock(BUILDER_PAYMENT_METHOD_ADDITIONAL_SELECTED, { methodType: methodType });
    }
    trackEnabledPaymentMethodAdditional(methodType) {
        this.PaymentSegmentService.trackPaymentBlock(BUILDER_PAYMENT_METHOD_ADDITIONAL_ENABLED, { enabled: methodType });
    }
}
//#endregion
//#region Constructor
PaymentMethodController.$inject = ['$timeout', '$scope', '$translate', 'PaymentSegmentService'];
PaymentMethodController.$inject = [
    '$timeout',
    '$scope',
    '$translate',
    'PaymentSegmentService',
];
export const PaymentMethod = {
    controller: PaymentMethodController,
    controllerAs: '$ctrl',
    template: view,
    bindings: {
        stateId: '<',
        state: '<',
        onPaymentMethodChange: '&?',
    },
};
